/* Nap (oct 2026): familias de producto (color, estampado o diseno) y grupos de medidas.
   1) Tarjeta: al pasar el cursor (o al primer toque en celular) cambian la foto, el precio y el enlace.
      Si el punto elegido no es el producto original de la tarjeta, el boton de compra de la tarjeta
      se cambia por "Compra rapida", que abre la vista rapida del producto elegido (ahi estan tallas
      y "Anadir al carrito"). Asi nunca se agrega al carrito un producto distinto al que se ve.
      Tarjeta de grupo de medidas: el boton siempre es "Elegir medida" (o "Elegir talla", segun
      data-nb-etiqueta) y abre la vista rapida.
   2) Vista rapida: se agregan los selectores de la ficha (medida y diseno) debajo del titulo; al elegir
      uno, la vista rapida carga ese producto sin cerrar la ventana.
      Tambien se quita el campo oculto de prueba properties[Test 123] que trae halo-quick-view.liquid
      y se oculta la fila "Tipo de Producto". */
(function () {
    var ultimoToque = 0;

    function esGrupo(card) {
        return !!card.querySelector('[data-nb-grupo]');
    }

    function boton(card) {
        var accion = card.querySelector('.card-action');
        if (!accion) return null;
        var ver = accion.querySelector('.nb-fam__ver');
        if (!ver) {
            ver = document.createElement('button');
            ver.type = 'button';
            ver.className = 'button button--primary nb-fam__ver';
            ver.setAttribute('data-open-quick-view-popup', '');
            var ojo = card.querySelector('[data-open-quick-view-popup][data-product-handle]');
            if (ojo) {
                ver.setAttribute('data-product-handle', ojo.getAttribute('data-product-handle'));
                ver.setAttribute('data-product-id', ojo.getAttribute('data-product-id') || '');
            }
            accion.insertBefore(ver, accion.firstChild);
        }
        var grupo = card.querySelector('[data-nb-grupo]');
        ver.textContent = grupo ? 'Elegir ' + (grupo.getAttribute('data-nb-etiqueta') || 'medida') : 'Compra rápida';
        return ver;
    }

    function preparar() {
        document.querySelectorAll('.product-item [data-nb-grupo]').forEach(function (g) {
            var card = g.closest('.product-item');
            if (!card || card.getAttribute('data-nb-listo')) return;
            card.setAttribute('data-nb-listo', '1');
            boton(card);
            card.classList.add('nb-fam-otro');
        });
    }

    function cambiar(dot) {
        var card = dot.closest('.product-item');
        if (!card) return;
        var src = dot.getAttribute('data-nb-img');
        var href = dot.getAttribute('href');
        var handle = dot.getAttribute('data-nb-handle');
        var pid = dot.getAttribute('data-nb-id');
        var esOriginal = dot.hasAttribute('data-nb-lead');
        var img = card.querySelector('.card-media img');
        if (img && src) {
            img.removeAttribute('data-srcset');
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
            img.setAttribute('data-src', src);
            img.src = src;
            card.classList.add('nb-fam-cambio');
        }
        card.querySelectorAll('a.card-link, a.card-title').forEach(function (a) {
            a.setAttribute('href', href);
            if (a.hasAttribute('data-product-url')) a.setAttribute('data-product-url', href);
        });
        var tpl = dot.parentElement ? dot.parentElement.querySelector('template') : null;
        if (tpl) {
            card.querySelectorAll('.card-price').forEach(function (p) { p.innerHTML = tpl.innerHTML; });
        }
        boton(card);
        card.querySelectorAll('[data-open-quick-view-popup]').forEach(function (b) {
            b.setAttribute('data-product-handle', handle);
            b.setAttribute('data-product-id', pid);
        });
        card.classList.toggle('nb-fam-otro', !esOriginal || esGrupo(card));
        card.querySelectorAll('.nb-fam__dot').forEach(function (d) {
            d.classList.toggle('is-active', d === dot);
        });
    }

    function punto(e) {
        return e.target && e.target.closest ? e.target.closest('.product-item .nb-fam__dot') : null;
    }

    function abrirVista(el) {
        var b = document.createElement('button');
        b.type = 'button';
        b.hidden = true;
        b.setAttribute('data-open-quick-view-popup', '');
        b.setAttribute('data-product-handle', el.getAttribute('data-nb-handle'));
        b.setAttribute('data-product-id', el.getAttribute('data-nb-id'));
        document.body.appendChild(b);
        b.click();
        b.remove();
    }

    document.addEventListener('touchstart', function () { ultimoToque = Date.now(); }, { passive: true });

    document.addEventListener('mouseover', function (e) {
        if (Date.now() - ultimoToque < 800) return;
        var dot = punto(e);
        if (dot && !dot.classList.contains('is-active')) cambiar(dot);
    });

    document.addEventListener('click', function (e) {
        var enVista = e.target && e.target.closest ? e.target.closest('.quickView .nb-fam__dot, .quickView .nb-fam__pill') : null;
        if (enVista) {
            e.preventDefault();
            if (!enVista.classList.contains('is-active')) abrirVista(enVista);
            return;
        }
        var dot = punto(e);
        if (!dot || dot.classList.contains('is-active')) return;
        e.preventDefault();
        cambiar(dot);
    });

    /* Vista rapida */
    function inyectar(q) {
        if (q.getAttribute('data-nb-listo')) return;
        q.setAttribute('data-nb-listo', '1');
        q.querySelectorAll('input[name="properties[Test 123]"]').forEach(function (i) { i.remove(); });
        q.querySelectorAll('.productView-info-item').forEach(function (i) {
            if (/tipo de producto/i.test(i.textContent)) i.style.display = 'none';
        });
        var titulo = q.querySelector('.productView-title');
        var a = titulo ? titulo.querySelector('a') : null;
        var m = a ? (a.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/) : null;
        if (!m) return;
        var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(raiz + 'products/' + m[1] + '?view=nb-familia')
            .then(function (r) { return r.ok ? r.text() : ''; })
            .then(function (h) {
                if (!h || h.indexOf('nb-fam--pdp') < 0) return;
                var caja = document.createElement('div');
                caja.innerHTML = h;
                var fam = caja.querySelector('.nb-fam--pdp');
                if (fam && titulo.parentNode && !q.querySelector('.nb-fam--pdp')) {
                    titulo.insertAdjacentElement('afterend', fam);
                }
            })
            .catch(function () {});
    }

    var pendiente = false;
    function revisar() {
        if (pendiente) return;
        pendiente = true;
        (window.requestAnimationFrame || setTimeout)(function () {
            pendiente = false;
            document.querySelectorAll('[data-quick-view-popup] .quickView').forEach(inyectar);
            preparar();
        });
    }

    if (window.MutationObserver) {
        new MutationObserver(revisar).observe(document.body, { childList: true, subtree: true });
    }
    revisar();
})();
